<template>
    <section class="mobile-messages-page">
        <van-nav-bar title="消息通知" left-arrow fixed placeholder z-index="100" safe-area-inset-top @click-left="goBack">
            <template #right><button class="mobile-messages-nav-action" type="button" @click="toggleEditing">{{ editing ? '完成' : '编辑' }}</button></template>
        </van-nav-bar>

        <main class="mobile-messages-main">
            <section class="mobile-messages-hero">
                <div><span>MESSAGE CENTER</span><h1>消息中心</h1><p>及时查看权益变化和业务通知。</p></div>
                <div class="mobile-messages-hero__unread"><strong>{{ unreadCount }}</strong><span>当前未读</span></div>
            </section>

            <div class="mobile-messages-filters">
                <button v-for="item in filters" :key="item.value" :class="{active: messageType === item.value}" type="button" @click="changeType(item.value)">
                    <van-icon :name="item.icon" /> {{ item.label }}
                </button>
            </div>

            <div class="mobile-messages-summary">
                <span>共 {{ total }} 条消息</span>
                <div><span>左滑可删除</span><button type="button" @click="refresh"><van-icon name="replay" /> 刷新</button></div>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多消息了" @load="loadMessages">
                <div v-if="messages.length" class="mobile-message-list">
                    <van-swipe-cell
                        v-for="message in messages"
                        :key="message.id"
                        :disabled="editing"
                        class="mobile-message-swipe"
                    >
                        <article
                            :class="['mobile-message-card', {unread: !isRead(message), selected: selectedIds.includes(message.id)}]"
                            @click="handleMessageClick(message)"
                        >
                            <div v-if="editing" class="mobile-message-card__check" @click.stop="toggleSelected(message.id)">
                                <van-checkbox :value="selectedIds.includes(message.id)" checked-color="#2478f2" />
                            </div>
                            <div :class="['mobile-message-card__icon', `mobile-message-card__icon--${messageColor(message)}`]">
                                <van-icon :name="messageIcon(message)" />
                                <span v-if="!isRead(message)" class="mobile-message-card__unread-dot"></span>
                            </div>
                            <div class="mobile-message-card__body">
                                <div class="mobile-message-card__title">
                                    <strong>{{ messageTitle(message) }}</strong>
                                    <small>{{ formatTime(message.create_time) }}</small>
                                </div>
                                <p>{{ messageTip(message) }}</p>
                                <div class="mobile-message-card__meta">
                                    <van-tag round plain>{{ messageTypeLabel(message) }}</van-tag>
                                    <span v-if="!isRead(message)">未读</span>
                                </div>
                            </div>
                            <van-icon v-if="!editing" name="arrow" class="mobile-message-card__arrow" />
                        </article>
                        <template #right>
                            <button class="mobile-message-swipe__delete" type="button" @click="deleteOne(message)">
                                <van-icon name="delete-o" />
                                <span>删除</span>
                            </button>
                        </template>
                    </van-swipe-cell>
                </div>
                <van-empty v-else-if="!loading" image="search" description="暂无消息通知" />
            </van-list>
        </main>

        <div v-if="editing" class="mobile-messages-actions">
            <button type="button" @click="toggleAll"><van-checkbox :value="allSelected" checked-color="#2478f2" /> <span>{{ allSelected ? '取消全选' : '全选' }}</span></button>
            <div>
                <van-button round plain type="info" size="small" :disabled="!selectedIds.length" @click="markSelectedRead">标为已读</van-button>
                <van-button round type="danger" size="small" :disabled="!selectedIds.length" @click="deleteSelected">删除</van-button>
            </div>
        </div>

        <van-popup v-model="detailVisible" position="right" :style="{width: '100%', height: '100%'}" safe-area-inset-top>
            <section class="mobile-message-detail">
                <van-nav-bar title="消息详情" left-arrow fixed placeholder z-index="110" safe-area-inset-top @click-left="detailVisible = false" />
                <div class="mobile-message-detail__heading">
                    <div :class="['mobile-message-card__icon', `mobile-message-card__icon--${messageColor(currentMessage)}`]"><van-icon :name="messageIcon(currentMessage)" /></div>
                    <div><span>{{ messageTypeLabel(currentMessage) }}</span><h2>{{ messageTitle(currentMessage) }}</h2><small>{{ formatTime(currentMessage.create_time) }}</small></div>
                </div>
                <iframe v-if="messageUrl(currentMessage)" :src="messageUrl(currentMessage)" title="消息详情" frameborder="0" />
                <div v-else class="mobile-message-detail__content">{{ messageTip(currentMessage) }}</div>
            </section>
        </van-popup>
    </section>
</template>

<script>
export default {
    name: 'MobileMessages',
    data() {
        return {
            baseUrl: '/bbs/message/index',
            messageType: '',
            messages: [],
            total: 0,
            pageNumber: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            editing: false,
            selectedIds: [],
            detailVisible: false,
            currentMessage: {},
            filters: [
                {label: '全部', value: '', icon: 'apps-o'},
                {label: '权益变化', value: 1, icon: 'medal-o'},
                {label: '业务消息', value: 2, icon: 'records-o'},
            ],
        };
    },
    computed: {
        unreadCount() { return this.messages.filter(item => !this.isRead(item)).length; },
        allSelected() { return Boolean(this.messages.length) && this.messages.every(item => this.selectedIds.includes(item.id)); },
    },
    methods: {
        goBack() { this.$router.push({path: '/user/profile/setting'}); },
        toggleEditing() {
            this.editing = !this.editing;
            this.selectedIds = [];
        },
        changeType(value) {
            if (this.messageType === value) return;
            this.messageType = value;
            this.refresh();
        },
        refresh() {
            this.messages = [];
            this.total = 0;
            this.pageNumber = 0;
            this.finished = false;
            this.selectedIds = [];
            this.loading = true;
            this.loadMessages();
        },
        loadMessages() {
            const nextPage = this.pageNumber + 1;
            const search = {};
            if (this.messageType) search.second_type = this.messageType;
            this.$bbs.get(this.baseUrl, {
                params: {search, sort: {}, total: this.total || 1, pageSize: this.pageSize, pageNumber: nextPage},
                need: {error: true},
            }).then(response => {
                const data = response.data || {};
                const list = Array.isArray(data.data) ? data.data.map(this.normalizeMessage) : [];
                this.messages = nextPage === 1 ? list : this.messages.concat(list);
                this.total = Number(data.total) || this.messages.length;
                this.pageNumber = Number(data.pageNumber) || nextPage;
                this.finished = !list.length || this.messages.length >= this.total;
            }).catch(() => { this.finished = true; }).finally(() => { this.loading = false; });
        },
        normalizeMessage(item) {
            if (typeof item.message === 'string') {
                try { return Object.assign({}, item, {message: JSON.parse(item.message)}); } catch (error) { return item; }
            }
            return item;
        },
        handleMessageClick(message) {
            if (this.editing) {
                this.toggleSelected(message.id);
                return;
            }
            this.currentMessage = message;
            this.detailVisible = true;
            if (!this.isRead(message)) this.markRead([message.id]);
        },
        toggleSelected(id) {
            const index = this.selectedIds.indexOf(id);
            if (index > -1) this.selectedIds.splice(index, 1);
            else this.selectedIds.push(id);
        },
        toggleAll() {
            this.selectedIds = this.allSelected ? [] : this.messages.map(item => item.id);
        },
        markSelectedRead() {
            this.markRead(this.selectedIds).then(() => {
                this.$toast.success('已标为已读');
                this.selectedIds = [];
            });
        },
        markRead(ids) {
            return this.$bbs.put(this.baseUrl, {ids, method: 'read'}, {need: {error: true}}).then(() => {
                this.messages.forEach(item => {
                    if (ids.includes(item.id)) this.$set(item, 'status', 1);
                });
            });
        },
        deleteSelected() {
            this.deleteMessages(this.selectedIds.slice());
        },
        deleteOne(message) {
            this.deleteMessages([message.id]);
        },
        deleteMessages(ids) {
            if (!ids.length) return;
            this.$dialog.confirm({
                title: '删除消息',
                message: ids.length === 1 ? '删除后将无法恢复，确认删除这条消息吗？' : `确认删除选中的 ${ids.length} 条消息吗？`,
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonColor: '#df4d55',
                closeOnClickOverlay: true,
            }).then(() => this.$bbs.delete(this.baseUrl, {data: {ids}, need: {error: true}})).then(() => {
                this.messages = this.messages.filter(item => !ids.includes(item.id));
                this.total = Math.max(this.total - ids.length, 0);
                this.selectedIds = this.selectedIds.filter(id => !ids.includes(id));
                if (!this.messages.length && this.total > 0) this.refresh();
                this.$toast.success('消息已删除');
            }).catch(() => {});
        },
        messageData(message) { return message && message.message && message.message.data || {}; },
        messageTitle(message) { return this.messageData(message).title || '消息通知'; },
        messageTip(message) { return this.messageData(message).tip || '点击查看消息详情'; },
        messageUrl(message) { return this.messageData(message).url || ''; },
        messageSecondType(message) { return Number(message.second_type || this.messageData(message).second_type || 0); },
        messageTypeLabel(message) { return this.messageSecondType(message) === 1 ? '权益变化' : this.messageSecondType(message) === 2 ? '业务消息' : '系统通知'; },
        messageIcon(message) { return this.messageSecondType(message) === 1 ? 'medal-o' : this.messageSecondType(message) === 2 ? 'records-o' : 'bell'; },
        messageColor(message) { return this.messageSecondType(message) === 1 ? 'gold' : this.messageSecondType(message) === 2 ? 'blue' : 'purple'; },
        isRead(message) { return Number(message.status) === 1; },
        formatTime(value) {
            if (!value) return '—';
            if (typeof value === 'string' && !/^\d{10,13}$/.test(value)) return value;
            const number = Number(value); const date = new Date(number < 1000000000000 ? number * 1000 : number); const pad = item => String(item).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
    },
};
</script>

<style scoped lang="less">
.mobile-messages-page { min-height: 100vh; color: #1d2738; background: #f4f6f9; }
.mobile-messages-page /deep/ .van-nav-bar--fixed { z-index: 100 !important; background: #fff; box-shadow: 0 1px 8px rgba(24,34,53,.06); }
.mobile-messages-page /deep/ .van-nav-bar__title { font-size: 17px; font-weight: 650; }
.mobile-messages-nav-action { padding: 6px 0; color: #2478f2; font-size: 14px; background: transparent; border: 0; }
.mobile-messages-main { padding: 12px 12px 90px; }
.mobile-messages-hero { display: flex; min-height: 127px; padding: 21px 19px; box-sizing: border-box; align-items: center; justify-content: space-between; color: #fff; background: radial-gradient(circle at 90% 8%,rgba(87,169,255,.38),transparent 31%),linear-gradient(140deg,#102b53,#236ac2); border-radius: 18px; box-shadow: 0 10px 27px rgba(32,91,170,.18); }
.mobile-messages-hero > div:first-child > span { color: #8fcaff; font-size: 9px; font-weight: 800; letter-spacing: 1.2px; }
.mobile-messages-hero h1 { margin: 6px 0 7px; font-size: 23px; }
.mobile-messages-hero p { margin: 0; color: rgba(255,255,255,.7); font-size: 12px; }
.mobile-messages-hero__unread { display: flex; width: 66px; height: 66px; flex: 0 0 66px; align-items: center; justify-content: center; flex-direction: column; background: rgba(255,255,255,.11); border: 1px solid rgba(255,255,255,.16); border-radius: 20px; }
.mobile-messages-hero__unread strong { font-size: 24px; }
.mobile-messages-hero__unread span { margin-top: 2px; color: rgba(255,255,255,.66); font-size: 10px; }
.mobile-messages-filters { display: grid; margin-top: 13px; padding: 5px; grid-template-columns: repeat(3,1fr); background: #e9edf3; border-radius: 12px; gap: 4px; }
.mobile-messages-filters button { height: 36px; color: #778294; font-size: 12px; background: transparent; border: 0; border-radius: 9px; }
.mobile-messages-filters button.active { color: #225fae; font-weight: 650; background: #fff; box-shadow: 0 3px 9px rgba(31,52,80,.08); }
.mobile-messages-summary { display: flex; padding: 16px 4px 9px; align-items: center; justify-content: space-between; color: #929baa; font-size: 12px; }
.mobile-messages-summary > div { display: flex; align-items: center; gap: 9px; }
.mobile-messages-summary > div > span { color: #a5adba; font-size: 10px; }
.mobile-messages-summary button { padding: 5px 8px; color: #3977c6; background: #e9f2ff; border: 0; border-radius: 999px; }
.mobile-message-list { display: grid; gap: 10px; }
.mobile-message-swipe { overflow: hidden; background: #fff; border-radius: 15px; box-shadow: 0 6px 19px rgba(31,48,73,.055); }
.mobile-message-card { position: relative; display: flex; width: 100%; min-height: 92px; padding: 15px 13px; box-sizing: border-box; align-items: center; background: #fff; border: 1px solid #e3e7ed; border-radius: 15px; gap: 11px; }
.mobile-message-card.unread { background: linear-gradient(145deg,#fff,#f4f9ff); border-left: 3px solid #3888ec; }
.mobile-message-card.selected { border-color: #86b9f5; background: #f3f8ff; }
.mobile-message-card__check { flex: none; }
.mobile-message-card__icon { position: relative; display: flex; width: 42px; height: 42px; flex: 0 0 42px; align-items: center; justify-content: center; font-size: 21px; border-radius: 13px; }
.mobile-message-card__icon > .van-icon { position: static; width: auto; height: auto; background: transparent; border: 0; }
.mobile-message-card__unread-dot { position: absolute; top: -2px; right: -2px; width: 8px; height: 8px; box-sizing: content-box; background: #f14f57; border: 2px solid #fff; border-radius: 50%; }
.mobile-message-card__icon--gold { color: #946919; background: linear-gradient(135deg,#fff0c5,#e3bb62); }
.mobile-message-card__icon--blue { color: #276ab8; background: linear-gradient(135deg,#e5f2ff,#a9d1fb); }
.mobile-message-card__icon--purple { color: #7055bb; background: linear-gradient(135deg,#f0ebff,#c7b6f3); }
.mobile-message-card__body { min-width: 0; flex: 1; }
.mobile-message-card__title { display: flex; min-width: 0; align-items: center; justify-content: space-between; gap: 8px; }
.mobile-message-card__title strong { overflow: hidden; color: #263247; font-size: 14px; font-weight: 650; text-overflow: ellipsis; white-space: nowrap; }
.mobile-message-card__title small { flex: none; color: #a1a9b5; font-size: 9px; font-weight: 400; }
.mobile-message-card__body p { display: -webkit-box; overflow: hidden; margin: 6px 0 8px; color: #697589; font-size: 12px; line-height: 18px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.mobile-message-card__meta { display: flex; height: 18px; align-items: center; gap: 7px; }
.mobile-message-card__meta /deep/ .van-tag { flex: none; padding: 1px 6px; font-size: 9px; }
.mobile-message-card__meta > span { color: #e45158; font-size: 10px; }
.mobile-message-card__arrow { color: #b0b7c2; font-size: 14px; }
.mobile-message-swipe__delete { display: flex; width: 72px; height: 100%; padding: 0; flex-direction: column; align-items: center; justify-content: center; gap: 5px; color: #fff; font-size: 12px; background: linear-gradient(145deg,#f06a70,#dc474f); border: 0; }
.mobile-message-swipe__delete .van-icon { font-size: 19px; }
.mobile-messages-actions { position: fixed; z-index: 1001; right: 0; bottom: calc(56px + env(safe-area-inset-bottom)); left: 0; display: flex; min-height: 58px; padding: 10px 13px; box-sizing: border-box; align-items: center; justify-content: space-between; background: #fff; border-top: 1px solid #e4e8ee; box-shadow: 0 -5px 18px rgba(30,47,70,.08); }
.mobile-messages-actions > button { display: flex; padding: 8px 0; align-items: center; color: #657186; font-size: 12px; background: transparent; border: 0; gap: 6px; }
.mobile-messages-actions > div { display: flex; gap: 8px; }
.mobile-message-detail { height: 100%; color: #1e2938; background: #f5f7f9; }
.mobile-message-detail__heading { display: flex; margin: 13px; padding: 17px 15px; align-items: center; background: #fff; border: 1px solid #e3e7ed; border-radius: 15px; gap: 12px; }
.mobile-message-detail__heading > div:last-child { min-width: 0; }
.mobile-message-detail__heading span { color: #5280ba; font-size: 10px; }
.mobile-message-detail__heading h2 { margin: 4px 0 6px; font-size: 18px; }
.mobile-message-detail__heading small { color: #9da6b2; font-size: 11px; }
.mobile-message-detail iframe { width: calc(100% - 26px); height: calc(100% - 160px); margin: 0 13px; background: #fff; border-radius: 14px; }
.mobile-message-detail__content { min-height: 180px; margin: 0 13px; padding: 18px; box-sizing: border-box; color: #586579; font-size: 14px; line-height: 1.7; background: #fff; border: 1px solid #e3e7ed; border-radius: 14px; }
</style>
